var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.56 302.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#006837;}.cls-3{fill:#333;}.cls-4{fill:#0e5638;}.cls-5{opacity:.4;}.cls-6{fill:#0e6038;}.cls-7{fill:#aae5af;}.cls-8{fill:#1a1a1a;}.cls-9{fill:#407f46;opacity:.5;}.cls-10{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.54,162c0,77.6,78.13,140.5,174.5,140.5s174.5-62.9,174.5-140.5S271.92,54.5,175.54,54.5,.54,84.4,.54,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.04,45.31c0,29.1,29.1,52.69,65,52.69s65-23.59,65-52.69S112.13,5,76.23,5,11.04,16.21,11.04,45.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.82,40.71c0,29.39,29.6,53.21,66.11,53.21s66.11-23.82,66.11-53.21S298.63,0,262.12,0s-66.3,11.33-66.3,40.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M13.82,43.94c0,25.95,25.77,46.98,57.56,46.98s57.56-21.03,57.56-46.98S103.33,8,71.54,8,13.82,18,13.82,43.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210.16,39.33c0,25.95,25.77,46.98,57.56,46.98s57.56-21.03,57.56-46.98S299.68,3.39,267.89,3.39s-57.73,10-57.73,35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.16,24.4c0,8.23,8.7,14.91,19.44,14.91s19.44-6.67,19.44-14.91-8.65-11.4-19.38-11.4-19.49,3.17-19.49,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.29,28.1c0,8.23,8.7,14.91,19.44,14.91s19.44-6.67,19.44-14.91-8.65-11.4-19.38-11.4-19.49,3.17-19.49,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.5,136.48c2.8,2.96,3.78-.32,6.37-2.77s5.78-3.12,2.99-6.08-5.95-2.13-8.54,.32-3.61,5.58-.82,8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.88,128.65c-3.6,1.89-.14,4.06,1.41,7.01,1.55,2.95,.61,5.57,4.21,3.67s3.74-5,2.19-7.95-4.2-4.63-7.81-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.54,140.07c9.96,7.09,9.8-4.9,16.59-14.43s17.96-12.99,8-20.08c-9.96-7.09-19.26-2.15-26.05,7.38-6.79,9.53-8.49,20.04,1.47,27.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.39,138.17c-9.96,7.09-9.8-4.9-16.59-14.43-6.79-9.53-17.96-12.99-8-20.08,9.96-7.09,19.26-2.15,26.05,7.38s8.49,20.04-1.47,27.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.43,157.71c-7.18,1.16-3.62-3.25-4.35-7.78-.73-4.52-5.47-7.45,1.71-8.6,7.18-1.16,10.53,2.04,11.26,6.56s-1.44,8.66-8.62,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.13,148.74c7.18,1.16,3.49-2.49,4.07-6.08s5.2-5.78-1.98-6.94c-7.18-1.16-10.41,1.29-10.99,4.89s1.72,6.97,8.89,8.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112.19,134.7c.76,3.88,3.72,6.08,7.02,7.84,3.27,1.89,6.36,4.29,8.67,7.32,0,0-.35,.3-.35,.3-2.64-2.67-5.59-4.86-8.87-6.69-1.6-.96-3.31-1.91-4.65-3.39-1.36-1.44-2.03-3.37-2.27-5.3,0,0,.46-.08,.46-.08h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M.54,162c-.22-.45-4.5,136,174.5,140.5,169.01,4.25,174.4-130.8,174-130.5-56.67,41.52-103.9,40.54-134.44,31.68-27.14-7.87-55.96-8.32-83.15-.62-41.46,11.74-104.41,11.94-130.91-41.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.02,161.7c6.62,8.6,16.62,24.22,26.56,28.1,31.27,8.8,63.77,6.38,95.68,2.96,23.1-2.32,48.05-4.52,71.59-.76,15.44,2.34,29.6,5.11,44.99,5.36,14.93,.47,30.52-.71,45.44-2.1,2.8-.32,8.26-.72,11.04-1.43,14.49-3.38,28.48-11.11,41.9-17.71,3.48-1.74,6.96-3.51,10.54-5.12,.29-.13,.62,0,.75,.29,.11,.25,.03,.54-.19,.69-12.61,9.06-24.85,18.75-39.12,26.17-3.57,1.86-7.29,3.53-11.26,4.9-3.21,1.11-8.4,2.33-11.77,3.2-15.44,3.79-31.15,6.63-47.1,7.5-15.72,1.05-32.35-1.02-47.64-2.97-15.04-1.82-29.56-1.66-44.69-.84-30.95,1.69-63.92,4.63-94.48-3.36-7.81-2.04-15.45-4.68-22.72-8.03-3.74-1.78-8.08-3.6-10.99-6.44C10.79,183.64,5.64,172.84,.06,162.3c-.14-.28-.03-.62,.25-.76,.25-.13,.55-.05,.71,.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301.79,104.79c-6.35,4.52,.87,6.87,5.15,12.87,4.28,6.01,4,13.4,10.35,8.88,6.35-4.52,5.35-11.11,1.07-17.11s-10.22-9.16-16.57-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.62,109.05c6.35,4.52-.87,6.87-5.15,12.87-4.28,6.01-4,13.4-10.35,8.88s-5.35-11.11-1.07-17.11c4.28-6.01,10.22-9.16,16.57-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81.57,127.24c4.21,3,.07,3.64-1.99,6.53-2.05,2.88-1.25,6.91-5.45,3.92s-4.17-6.47-2.12-9.36,5.35-4.08,9.56-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M277.48,116.7c-4.21,3-.07,3.64,1.99,6.53s1.25,6.91,5.45,3.92,4.17-6.47,2.12-9.36-5.35-4.08-9.56-1.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.74,137.93c0,4.23-3.02,7.08-6.34,9.13-3.15,2.04-5.95,4.43-8.41,7.27,0,0-.37-.28-.37-.28,2.1-3.17,5.02-5.78,8.16-7.88,3.18-1.98,5.99-4.37,6.49-8.29,0,0,.46,.05,.46,.05h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.06,60.01c0,11.87,16.39-.5,36-.5s35,12.37,35,.5-15.89-21.5-35.5-21.5-35.5,9.63-35.5,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.24,123.16c.13,2.83,2.48-1.27,6.78-1.46,4.29-.2,4.67,5.77,7.99,6.95,4.43,1.57-3.75-10.11-8.22-9.9s-6.68,1.58-6.55,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.69,128.48c1.2,2.17,1.6-2.03,5.14-3.98,3.53-1.95,6.14,2.59,9.38,2.13,4.33-.61-7.04-6.38-10.71-4.35s-5.01,4.03-3.81,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.34,139.9c-.02-1.66-1.48,.69-3.99,.71s-2.6-3.47-4.52-4.23c-2.55-1.01,1.98,5.99,4.59,5.96s3.93-.78,3.92-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.53,140.4c.79-1.48,1.07,1.35,3.42,2.61s4.08-1.83,6.24-1.56c2.88,.36-4.68,4.39-7.12,3.07-2.35-1.27-3.34-2.65-2.54-4.13Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrog);
export default __webpack_public_path__ + "static/media/FROG.e3037d9e7e807e1b0b9f8df6290deed2.svg";
export { ForwardRef as ReactComponent };